import React from 'react';
import { LS_Attribute } from '../types/labelSchema';

type Props = {
  attrs: LS_Attribute[];
  value: Record<string, any>;
  onChange: (next: Record<string, any>) => void;
};

export default function AttributeForm({ attrs, value, onChange }: Props) {
  function set(id: string, v: any) {
    onChange({ ...value, [id]: v });
  }
  return (
    <div className="space-y-3">
      {attrs.map(a => {
        const v = value[a.id];
        if (a.type === 'enum') return (
          <label key={a.id} className="block">
            <span className="text-sm">{a.label}{a.required && ' *'}</span>
            <select className="mt-1 w-full border rounded p-2"
              value={v ?? a.default ?? ''}
              onChange={e=>set(a.id, e.target.value)}>
              <option value="" disabled>Select…</option>
              {(a.options||[]).map(opt=><option key={opt} value={opt}>{opt}</option>)}
            </select>
          </label>
        );
        if (a.type === 'multi_enum') return (
          <label key={a.id} className="block">
            <span className="text-sm">{a.label}{a.required && ' *'}</span>
            <div className="mt-1 flex flex-wrap gap-2">
              {(a.options||[]).map(opt=>{
                const checked = Array.isArray(v) && v.includes(opt);
                return (
                  <label key={opt} className="inline-flex items-center gap-2 border rounded px-2 py-1">
                    <input type="checkbox" checked={!!checked}
                      onChange={(e)=>{
                        const cur = Array.isArray(v)? v.slice() : [];
                        const next = e.target.checked ? [...cur, opt] : cur.filter(x=>x!==opt);
                        set(a.id, next);
                      }} />
                    <span>{opt}</span>
                  </label>
                );
              })}
            </div>
          </label>
        );
        if (a.type === 'boolean') return (
          <label key={a.id} className="flex items-center gap-2">
            <input type="checkbox" checked={!!v || a.default === true} onChange={e=>set(a.id, e.target.checked)} />
            <span className="text-sm">{a.label}</span>
          </label>
        );
        if (a.type === 'number') return (
          <label key={a.id} className="block">
            <span className="text-sm">{a.label}{a.required && ' *'}</span>
            <input type="number" className="mt-1 w-full border rounded p-2"
              value={v ?? ''} onChange={e=>set(a.id, e.target.value === '' ? undefined : Number(e.target.value))}
              min={(a as any).min} max={(a as any).max} step={(a as any).step ?? 1}/>
          </label>
        );
        // text
        return (
          <label key={a.id} className="block">
            <span className="text-sm">{a.label}{a.required && ' *'}</span>
            <input type="text" className="mt-1 w-full border rounded p-2"
              value={v ?? ''} onChange={e=>set(a.id, e.target.value)} />
          </label>
        );
      })}
    </div>
  );
}
